'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _removeAccentsDiacritics = require('remove-accents-diacritics');

var _removeAccentsDiacritics2 = _interopRequireDefault(_removeAccentsDiacritics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var accentOnly = _removeAccentsDiacritics2.default.remove;
var lowerOnly = function lowerOnly(t) {
  return t.toLowerCase();
};
var accentAndLower = _lodash2.default.flowRight(lowerOnly, accentOnly);

function normaliseText(text, ignoreAccents, ignoreCase) {
  var t = text || '';
  if (ignoreAccents && ignoreCase) t = accentAndLower(t);else if (ignoreAccents) t = accentOnly(t);else if (ignoreCase) t = lowerOnly(t);
  return t;
}

/**
 * Filters the options by their label.
 * eg. If a given option's label includes the given input term, it is added.
 * @param {Array} options
 * @param {{inputValue,pluckLabel,ignoreAccents,ignoreCase}} props
 */
function filterByLabel(options, props) {
  var inputValue = props.inputValue,
      pluckLabel = props.pluckLabel,
      ignoreAccents = props.ignoreAccents,
      ignoreCase = props.ignoreCase;


  return options.reduce(function (options, option) {
    var label = pluckLabel(option);
    var normalisedOptionLabel = normaliseText(label, ignoreAccents, ignoreCase);
    var normalisedTerm = normaliseText(inputValue, ignoreAccents, ignoreCase);

    if (normalisedOptionLabel.includes(normalisedTerm)) {
      options.push(option);
    }
    return options;
  }, []);
}

exports.default = filterByLabel;